import { Injectable } from '@angular/core';
import { QuestionAttemptEntityQuery, QuestionAttemptEntityService } from '@examdojo/question';
import { concatMap, distinctUntilChanged, filter, forkJoin, merge, startWith, switchMap } from 'rxjs';
import { StreakService } from '../streak';
import { UserMarksService } from '../user/mark/user-marks.service';

@Injectable()
export class UpdateUserMarksOnAttemptGradedService {
  constructor(
    private readonly questionAttemptService: QuestionAttemptEntityService,
    private readonly questionAttemptQuery: QuestionAttemptEntityQuery,
    private readonly userMarksService: UserMarksService,
    private readonly streakService: StreakService,
  ) {
    this.questionAttemptService.attemptGraded$
      .pipe(
        concatMap(() =>
          merge(
            this.userMarksService.getUserSpentPointsAndLimits(),

            this.questionAttemptQuery.questionGradingAwardedPoints$.pipe(
              startWith(null),
              distinctUntilChanged(),
              filter((points) => !!points),
              switchMap(() =>
                forkJoin([this.userMarksService.fetchLastWeekUserMarks(), this.streakService.fetchStreaks()]),
              ),
            ),
          ),
        ),
      )
      .subscribe();
  }
}
